import { render, staticRenderFns } from "./CourseRecDialog.vue?vue&type=template&id=26663c9a&scoped=true&"
import script from "./CourseRecDialog.vue?vue&type=script&lang=js&"
export * from "./CourseRecDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26663c9a",
  null
  
)

export default component.exports